export default __webpack_public_path__ + "static/media/WM0490.34I-43516_-26036_0.460b6ec7.jpg";